import { HomeContainer } from '../../container';

const HomePage = () => {
  return <HomeContainer />;
};

export default HomePage;
